  function increaseQuantity(button) {
    const input = button.parentNode.querySelector('.product-upsell-block__quantity-input');
    input.value = parseInt(input.value) + 1;
  }

  function decreaseQuantity(button) {
    const input = button.parentNode.querySelector('.product-upsell-block__quantity-input');
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  }

  function updateVariant(selectElement, productId) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const variantId = selectedOption.value;
    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;
    const isAvailable = selectedOption.dataset.available === 'true';
    
    // Find the product block container
    const productBlock = selectElement.closest('.product-upsell-block');
    
    // Update hidden input value
    const hiddenInput = productBlock.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }
    
    // Update price display
    const priceElement = productBlock.querySelector('.product-upsell-block__price');
    if (priceElement) {
      let priceHTML = '';
      
      // Add compare at price if it exists and is greater than current price
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        priceHTML += `<span style="text-decoration: line-through; color: #999; margin-right: 0.5rem;">
          $${(parseInt(comparePrice) / 100).toFixed(2)}
        </span>`;
      }
      
      // Add current price
      priceHTML += `$${(parseInt(price) / 100).toFixed(2)}`;
      priceElement.innerHTML = priceHTML;
    }
    
    // Update add to cart button
    const addToCartBtn = productBlock.querySelector('.product-upsell-block__add-to-cart');
    if (addToCartBtn) {
      // Update variant-id attribute
      addToCartBtn.setAttribute('variant-id', variantId);
      
      // Update onclick function
      addToCartBtn.setAttribute('onclick', `addToCartUpCart(this, '${variantId}')`);
      
      // Update button state based on availability
      const textSpan = addToCartBtn.querySelector('.add-to-cart-text');
      if (isAvailable) {
        addToCartBtn.disabled = false;
        if (textSpan) {
          textSpan.textContent = 'Add To Cart';
        }
      } else {
        addToCartBtn.disabled = true;
        if (textSpan) {
          textSpan.textContent = 'Sold Out';
        }
      }
    }
  }

  function addToCartUpCart(button, variantId) {
    const form = button.closest('form');
    const textSpan = button.querySelector('.add-to-cart-text');
    const loadingSpan = button.querySelector('.add-to-cart-loading');

    // Show loading state
    button.disabled = true;
    textSpan.style.display = 'none';
    loadingSpan.style.display = 'flex';

    const formData = {
      id: variantId,
      quantity: 1,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Success - show feedback
        textSpan.textContent = 'Added!';
        textSpan.style.display = 'inline';
        loadingSpan.style.display = 'none';

        // Trigger UpCart drawer if available
        if (window.UpCart && window.UpCart.open) {
          window.UpCart.open();
        }

        // Reset button after 2 seconds
        setTimeout(() => {
          textSpan.textContent = 'Add To Cart';
          button.disabled = false;
        }, 2000);

        console.log('Product added to cart:', data);
      })
      .catch((error) => {
        // Error handling
        console.error('Error adding to cart:', error);
        textSpan.textContent = 'Error';
        textSpan.style.display = 'inline';
        loadingSpan.style.display = 'none';

        // Reset button after 3 seconds
        setTimeout(() => {
          textSpan.textContent = 'Add To Cart';
          button.disabled = false;
        }, 3000);
      });
  }